import { LayerSpecification, Map } from 'maplibre-gl';
import { DAISI_LAYER, DAISI_SOURCE } from './daisi-layer';

export const BEARING_LAYER: LayerSpecification = {
  id: 'incidents-bearing-' + DAISI_LAYER.id,
  type: 'symbol',
  source: DAISI_SOURCE,
  layout: {
    'icon-image': 'bearing',
    'icon-size': 0.9,
    'icon-rotate': ['coalesce', ['get', 'bearing'], 0],
    'icon-rotation-alignment': 'map',
    'icon-allow-overlap': true,
    'icon-ignore-placement': true,
    'icon-offset': [0, -20],
  },
  filter: ['has', 'bearing'],
};

export async function addBearingImage(map: Map) {
  const resp = await map.loadImage('../assets/icons/bearing.png');
  map.addImage('bearing', resp.data);
}
